import React from 'react';
import PropTypes from 'prop-types';

export const DynivyLogo = ({ logoType, wSize }) => {
  const getImageLocation = (type) => {
    switch (type) {
      case 'logo':
        return '/assets/dynivy.svg';
      case 'logoInvert':
        return '/assets/dynivy_white.svg';
      case 'logoName':
        return '/assets/dynivy_name.svg';
      case 'logoNameInvert':
        return '/assets/dynivy_name_white.svg';
      default:
        return '/assets/dynivy.svg';
    }
  };

  return (
    <div>
      <img src={getImageLocation(logoType)} width={wSize || '132px'} />
    </div>
  );
};

DynivyLogo.propTypes = {
  logoType: PropTypes.string.isRequired,
  wSize: PropTypes.string,
};
